<template>
    <div v-if="status === 'loading'" class="ds-dossier-skeleton" :style="{ height: `${height}px` }" aria-busy="true" aria-label="Загрузка"></div>
    <div v-else-if="status === 'forbidden'" class="ds-dossier-state" :class="{ 'is-plain': plain }">Недоступно с текущими правами</div>
    <div v-else-if="status === 'error'" class="ds-dossier-state" :class="{ 'is-plain': plain }" role="alert">
        <span>{{ errorText }}</span>
        <button type="button" class="ds-glass-btn ds-glass-btn-secondary" @click="emit('retry')">Повторить</button>
    </div>
</template>

<script setup lang="ts">
import type { BlockStatus } from './dossierModel'

// Независимое состояние блока досье: остальные блоки продолжают работать.
withDefaults(defineProps<{
    status: BlockStatus
    height?: number
    errorText?: string
    plain?: boolean
}>(), {
    height: 64,
    errorText: 'Не удалось загрузить',
    plain: false,
})

const emit = defineEmits<{ retry: [] }>()
</script>
